import { useState } from 'react';

import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';

import { Layout, Modal } from '~/components';

import {
  TrainingStoreModalContainer,
  Container,
  Navigator,
  NavigatorTitle,
} from './styles';

function Lab() {
  const { push } = useHistory();
  const [showTrainingStoreModal, setShowTrainingStoreModal] = useState(false);

  function TrainingStoreModal() {
    return (
      <Modal
        isOpen={showTrainingStoreModal}
        setOpen={setShowTrainingStoreModal}
      >
        <TrainingStoreModalContainer>
          <button
            type="button"
            onClick={() =>
              push('/professional/lab/training-store/profile-code')
            }
          >
            <p>ProfileCode</p>
          </button>

          <button
            type="button"
            onClick={() =>
              push('/professional/lab/training-store/technical-data')
            }
          >
            <p>Dados Técnicos</p>
          </button>
        </TrainingStoreModalContainer>
      </Modal>
    );
  }

  return (
    <Layout title="I.LAB">
      <TrainingStoreModal />

      <Container>
        <Navigator onClick={() => push('/professional/lab/power-creator')}>
          <NavigatorTitle>Power Creator</NavigatorTitle>
          <IoIosArrowBack size={32} />
        </Navigator>

        <Navigator onClick={() => push('/professional/lab/met-library')}>
          <NavigatorTitle>MET - Library</NavigatorTitle>
          <IoIosArrowBack size={32} />
        </Navigator>

        <Navigator onClick={() => push('/professional/lab/ex-editor')}>
          <NavigatorTitle>Ex - Editor</NavigatorTitle>
          <IoIosArrowBack size={32} />
        </Navigator>

        <Navigator onClick={() => push('/professional/lab/ex-library')}>
          <NavigatorTitle>Ex - Library</NavigatorTitle>
          <IoIosArrowBack size={32} />
        </Navigator>

        <Navigator onClick={() => setShowTrainingStoreModal(true)}>
          <NavigatorTitle>Training - Store</NavigatorTitle>
          <IoIosArrowBack size={32} />
        </Navigator>

        <Navigator onClick={() => push('/professional/lab/symbology')}>
          <NavigatorTitle>Simbologia</NavigatorTitle>
          <IoIosArrowBack size={32} />
        </Navigator>
      </Container>
    </Layout>
  );
}

export default Lab;
